import React, { useEffect, useState } from "react";
import "react-quill/dist/quill.snow.css";
import ReactQuill from "react-quill";
import axiosInstance from "../../../../axios";
import { FaEdit, FaTrash } from "react-icons/fa";
import Modal from "../../../Other/Modal";

const { REACT_APP_LOGIN_API_BASEURL } = process.env;

export default function CourseProject() {
  const [projects, setProjects] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [courses, setCourses] = useState([]);
  const [error, setError] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [projectToDelete, setProjectToDelete] = useState(null);

  const [projectData, setProjectData] = useState({
    id: "",
    projectDetails: "",
    status: 1,
    courseId: "",
  });

  useEffect(() => {
    loadProjects();
    fetchCourses();
  }, []);

  const loadProjects = async () => {
    try {
      const res = await axiosInstance.get(
        `${REACT_APP_LOGIN_API_BASEURL}/courses/project`
      );
      if (res?.data?.success) {
        setProjects(res?.data?.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const fetchCourses = async () => {
    try {
      const response = await axiosInstance.get(
        `${REACT_APP_LOGIN_API_BASEURL}/course`
      );
      setCourses(response.data?.data?.data || []);
    } catch (err) {
      console.error("Error fetching courses:", err);
      setCourses([]);
    }
  };

  const handleShowModal = (project = null) => {
    if (project) {
      setIsEditing(true);
      setProjectData({
        id: project.id,
        projectDetails: project.projectDetails,
        status: project.status,
        courseId: project.courseId,
      });
    } else {
      setIsEditing(false);
      setProjectData({ id: "", projectDetails: "", status: 1, courseId: "" });
    }
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isEditing) {
        await axiosInstance.put(
          `${REACT_APP_LOGIN_API_BASEURL}/courses/project/${projectData.id}`,
          projectData
        );
      } else {
        await axiosInstance.post(
          `${REACT_APP_LOGIN_API_BASEURL}/courses/project`,
          projectData
        );
      }
      loadProjects();
      handleCloseModal();
    } catch (err) {
      console.error("Error saving project:", err);
      setError("Error saving project");
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this project?")) {
      try {
        await axiosInstance.delete(
          `${REACT_APP_LOGIN_API_BASEURL}/courses/project/${id}`
        );
        loadProjects();
      } catch (err) {
        console.error("Error deleting project:", err);
        setError("Error deleting project");
      }
    }
  };

  const handleShowDeleteModal = (id) => {
    setProjectToDelete(id);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await axiosInstance.delete(
        `${REACT_APP_LOGIN_API_BASEURL}/courses/project/${projectToDelete}`
      );
      loadProjects();
      setShowDeleteModal(false);
      setProjectToDelete(null);
    } catch (err) {
      console.error("Error deleting project:", err);
      setError("Error deleting project");
    }
  };

  return (
    <div className="container mx-auto px-5 mt-3">
      <h1 className="text-2xl font-bold mb-4 p-4 bg-[#264b82] text-white rounded-md mt-0">
        All Projects
      </h1>

      <div className="flex justify-end">
        <button
          onClick={() => handleShowModal()}
          className="mb-3 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
        >
          Add Project
        </button>
      </div>

      <div className="instructor-table">
        <table className="table-width-100">
          <thead>
            <tr className="">
              <th>ID</th>
              <th>Project Details</th>
              <th>Course Title</th>
              <th>Created On</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {projects.length === 0 ? (
              <tr>
                <td colSpan="5" className="text-center py-4">
                  No records found
                </td>
              </tr>
            ) : (
              projects.map((project) => (
                <tr key={project.id}>
                  <td className="cell">{project.id}</td>
                  <td
                    dangerouslySetInnerHTML={{ __html: project.projectDetails }}
                    style={{ width: "auto" }}
                    className="cell"
                  />
                  <td className="cell">{project.courseTitle}</td>
                  <td className="cell">
                    {new Date(project.createdOn).toLocaleString()}
                  </td>
                  <td className="cell space-x-2">
                    <button
                      onClick={() => handleShowModal(project)}
                      className=""
                    >
                      <FaEdit />
                    </button>
                    <button
                      onClick={() => handleShowDeleteModal(project.id)}
                      className=""
                    >
                      <FaTrash />
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {showModal && (
        <Modal isOpen={showModal} onClose={handleCloseModal}>
          <div className="">
            <div className="dashboard-container-new !mb-5">
              <p> {isEditing ? "Edit Project" : "Add New Project"}</p>
            </div>
            <form onSubmit={handleSubmit} className="space-y-4">
              <label className="block mb-2 font-medium">Select Course</label>
              <select
                value={projectData.courseId}
                onChange={(e) =>
                  setProjectData({ ...projectData, courseId: e.target.value })
                }
                className="w-full border border-gray-300 p-2 mb-4 rounded"
                required
              >
                <option value="">Select Course</option>
                {courses.map((course) => (
                  <option key={course.ID} value={course.ID}>
                    {course.CourseName}
                  </option>
                ))}
              </select>
              <div>
                <label className="block font-medium mb-1">
                  Project Details
                </label>
                <ReactQuill
                  theme="snow"
                  value={projectData.projectDetails}
                  onChange={(value) =>
                    setProjectData({ ...projectData, projectDetails: value })
                  }
                  className="h-28 mb-10 !text-start !text-black"
                />
              </div>
              <button
                type="submit"
                className="w-full bg-[#264b82] text-white p-3 rounded hover:bg-[#264b82]"
              >
                {isEditing ? "Update Project" : "Submit"}
              </button>
            </form>
          </div>
        </Modal>
      )}

      {showDeleteModal && (
        <Modal
          isOpen={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
        >
          <div className="p-6 bg-white rounded-lg shadow-lg">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              Confirm Delete
            </h2>
            <p className="text-gray-600 mb-6">
              Are you sure you want to delete this project? This action cannot
              be undone.
            </p>
            <div className="flex justify-end space-x-4">
              <button
                onClick={() => setShowDeleteModal(false)}
                className="px-5 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition duration-200"
              >
                Cancel
              </button>
              <button
                onClick={handleConfirmDelete}
                className="px-5 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition duration-200"
              >
                Delete
              </button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}
